import axios from 'axios'

const instance = axios.create({
    //baseURL: 'http://cnshaappuwv750.asia.pwcinternal.com:38601/',
    // timeout: 10000,
    headers: {
        'content-type': 'application/json'
    }
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.interceptors.response.use(function (response) {
    // console.log(response);
    return response;
}, function (error) {
    if (error != null && error.response != null && error.response.status === 401) {
        window.location.href = '/home/app#/login';
        //window.location.href = error.response.data;
    }
    return Promise.reject(error);
});

export default {
    getKeyValueList: function () {
        return instance.get('/api/CommonData/GetKeyValueList');
    },
    getCommonInfo: function (category) {
        var param = JSON.stringify(category);
        return instance.post('/api/CommonData/Get', param);
    },
    getCommonData: function (category) {
        var param = JSON.stringify(category);
        return instance.post('/api/CommonData/GetCommonData', param);
    },
    addRelationship: function (addInfo) {
        var param = JSON.stringify(addInfo);
        return instance.post('/api/Relationship/Add', param);
    },
    getRelationshipInfo: function (id) {
        return instance.get('/api/Relationship/Details?id=' + id);
    },
    getRelationshipList: function (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/Search', param);
    },
    addInvestedCompanyContact: function (addInfo) {
        var param = JSON.stringify(addInfo);
        return instance.post('/api/InvestedCompanyContact/Add', param);
    },
    getMemberList: function (companyId, name) {
        return instance.get(`/api/InvestedCompanyContact/GetMemberList?companyId=${companyId}&name=${name}`);
    },
    getInvestedCompanyContactDetails: function (id) {
        return instance.get(`/api/InvestedCompanyContact/GetMemberDetails?id=${id}`);
    },
    getInvestedCompanyContactRelationships: function (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/InvestedCompanyContact/GetRelationships', param);
    },
    searchContractListWithCompany (serchParam) {
        return instance.post('/api/InvestedCompanyContact/SearchContractListWithCompany', serchParam);
    },
    searchContractListGroupByCompany (serchParam) {
        return instance.post('/api/InvestedCompanyContact/SearchContractListGroupByCompany', serchParam);
    },
    SearchMemberHisList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/InvestedCompanyContact/SearchMemberHisList', param);
    },
    getUserProfileInfo: function (id) {
        return instance.get('/api/UserProfile/GetUserProfileInfo?id=' + id);
    },
    getManagerList: function () {
        return instance.get('/api/UserProfile/getManagerList');
    },
    addFavoriteRelationship (param) {
        var param = JSON.stringify(param);
        return instance.post('/api/Favorite/AddFavoriteRelationship', param);
    },
    deleteFavoriteRelationship (param) {
        // var param = JSON.stringify(param);
        return instance.post('/api/Favorite/DeleteFavoriteRelationship', param);
    },
    getFavoriteDetail (orgId) {
        return instance.get('/api/Favorite/GetDetail?orgId=' + orgId);
    },
    getFavoriteRelationships (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Favorite/GetFavoriteRelationships', filter);
    },
    GetUserFavoriteRelationshipsByRelId (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Favorite/GetUserFavoriteRelationshipsByRelId', filter);
    },
    deleteRelationshipsByIds (ids) {
        var param = JSON.stringify(ids);
        return instance.post('/api/Relationship/Delete', param);
    },
    getRelationshipsByIds (ids) {
        var param = JSON.stringify(ids);
        return instance.post('/api/Relationship/GetRelationshipsByIds', param);
    },
    getSearchHistoryList (userId, topNum, type) {
        return instance.get('/api/UserProfile/GetSearchHistoryList?id=' + userId + '&topNum=' + topNum + '&type=' + type);
    },
    deleteSearchHistory (userId, type) {
        return instance.delete('/api/UserProfile/DeleteSearchHistory?userId=' + userId + '&type=' + type);
    },
    addSearchHistory (addInfo) {
        var param = JSON.stringify(addInfo);
        return instance.post('/api/UserProfile/AddSearchHistory', param);
    },
    addViewHistory (addInfo) {
        var param = JSON.stringify(addInfo);
        return instance.post('/api/UserProfile/AddViewHistory', param);
    },
    getOrgList () {
        return instance.get('/api/Relationship/GetOrgList');
    },
    searchOrgList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/SearchOrgList', param);
    },
    newSearchOrgList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/NewSearchOrgList', param);
    },
    getMyRelationships: function (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/GetMyRelationships', param);
    },
    getMyFavoriteRelationships: function (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/GetMyFavoriteRelationships', param);
    },
    getContactList (relateId, name, relateType) {
        return instance.get('/api/PEContact/GetContactList?relateId=' + relateId + '&name=' + name + '&relateType=' + relateType);
    },
    getOrganizationsByName (search) {
        return instance.get('/api/PEOrganization/GetOrganizationsByName?search=' + search);
    },
    searchContractList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/SearchContractList', param);
    },
    searchContractListGroupByPE (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/SearchContractListGroupByPE', param);
    },
    getContactRelationshipCount (contactId) {
        return instance.get('/api/PEContact/GetContactRelationshipCount?contactId=' + contactId);
    },
    getPEDetails (id) {
        return instance.get('/api/PEOrganization/Details?id=' + id);
    },
    GetInvestedCompanyList (filter) {
        return instance.post('/api/PEOrganization/GetInvestedCompanyList', filter);
    },
    getOrgNewsList (apiId, filter) {
        return instance.post('/api/PEOrganization/GetNewsList?apiId=' + apiId, filter);
    },
    getContactDetails (id) {
        return instance.get('/api/PEContact/GetContactDetails?id=' + id);
    },
    getContactRelationships (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/PEContact/GetContactRelationships', filter);
    },
    getContactsByPEVCId (id) {
        return instance.get('/api/PEContact/GetContactsByPEVCId?id=' + id);
    },
    //********************* 被投公司 接口  start  ********************* 
    getCompanysByName (search) {
        return instance.get('/api/Invested/GetCompanysByName?search=' + search);
    },
    getInvestedDetail (id) {
        return instance.get('/api/Invested/GetDetail?id=' + id);
    },
    GetLastInvestedCompany (pEContactId) {
        return instance.get('/api/Invested/GetLastInvestedCompany?pEContactId=' + pEContactId);
    },
    getCompanyList (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Invested/GetCompanyList', param);
    },
    getInvestedNewsList (apiId, filter) {
        // var param = JSON.stringify(apiId,filter);
        return instance.post('/api/Invested/GetNewsList?apiId=' + apiId, filter);
    },
    getCompanyListFavorite (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Invested/GetCompanyListFavorite', param);

    },
    searchAllList (searchValue) {
        return instance.get('/api/Relationship/SearchAllList?searchValue=' + searchValue);
    },
    getPEOrganizationCompanys (id) {
        return instance.get('/api/PEOrganization/getPEOrganizationCompanys?id=' + id);
    },
    // ********************* 被投公司 接口  end  ********************* 
    getComments (relid) {
        return instance.get('/api/Comments/GetComments?relId=' + relid);

    },
    addComment (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Comments/AddComment', param);
    },
    searchRelationByName (tabIndex, search) {
        return instance.get('/api/Relationship/SearchRelationByName?tabIndex=' + tabIndex + '&search=' + search);
    },
    // ********************* 查看记录 接口  start  ********************* 
    //关系网
    getHistoryRelationships: function (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/GetHistoryRelationships', param);
    },
    //机构
    searchOrgHistoryList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/SearchOrgHistoryList', param);
    },

    //联系人
    searchContractHisList (serchParam) {
        var param = JSON.stringify(serchParam);
        return instance.post('/api/Relationship/SearchContractHisList', param);
    },

    //被投公司
    getCompanyListHistory (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/Invested/GetCompanyListHistory', param);

    },
    // ********************* 查看记录 接口  end  ********************* 



    //********************* 首页新闻 接口  start  ********************* 
    getNewsById (newsId) {
        return instance.get('/api/NewsInfo/GetNewsById?newsId=' + newsId);
    },
    getNewsList (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetNewsList', param);
    },
    GetFavoriteNews (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetFavoriteNews', param);
    },
    getHistoryNews (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetHistoryNews', param);
    },
    getMarketNewsById (newsId) {
        return instance.get('/api/NewsInfo/GetMarketIntelligenceById?id=' + newsId);
    },
    getMargetNewsList (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetMarketIntelligenceList', param);
    },
    GetFavoriteMarketIntelligence (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetFavoriteMarketIntelligence', param);
    },
    GetHistoryMarketIntelligence (filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/NewsInfo/GetHistoryMarketIntelligence', param);
    },

    getMenusList () {
        return instance.get('/api/admin/MarketIntelligence/GetMenusListApp');
    },
    // ********************* 首页新闻 接口  end  ********************* 

    //********************* 我的页面 接口  start  ********************* 
    logout () {
        return instance.get('/api/admin/User/Logout');
    },
    login (loginInfo) {
        var param = JSON.stringify(loginInfo);
        return instance.post('/api/Account/Login', param);
    },
    syncStaffBank () {
        return instance.get('/api/admin/XiNiu/SyncStaffBank');
    },
    // ********************* 我的页面 接口  end  ********************* 

    //机构
    getNewsFundingList (id, filter) {
        return instance.post('/api/PEOrganization/GetNewsFundingList?investorId=' + id, filter);
    },
    getFundingList (id, filter) {

        var param = JSON.stringify(filter);
        return instance.post('/api/PEOrganization/GetFundingList?investorId=' + id, filter);
    },
    getExitSalesList (id, filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/PEOrganization/GetExitSalesList?investorId=' + id, param);
    },
    getExitIPOList (id, filter) {
        var param = JSON.stringify(filter);
        return instance.post('/api/PEOrganization/GetExitIPOList?investorId=' + id, param);
    },
};



// WEBPACK FOOTER //
// ./src/network/webService.js